export const Header = [{
  prop: 'EQUIP_ID',
  label: '智能称编号'
}, {
  prop: 'SIM_ID',
  label: '手机卡号'
}, {
    prop: 'EQUIP_BATCH_NO',
    label: '智能称批次'
}, {
    prop: 'COMMENTS',
    label: '备注'
}]

